import * as React from "react";
const SvgFiRrLevelDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-level-down_svg__a)">
      <path
        fill="#062147"
        d="M17.713 18.233a1 1 0 0 0-1.414-.011l-2.885 2.834c-.108.108-.255.244-.414.389V5a5.006 5.006 0 0 0-5-5H1a1 1 0 0 0 0 2h7a3 3 0 0 1 3 3v16.445a15 15 0 0 1-.42-.395L7.7 18.222a.999.999 0 0 0-1.734.712 1 1 0 0 0 .334.713l2.872 2.823c.2.2.513.487.84.777a3 3 0 0 0 3.977 0c.326-.289.636-.572.833-.769l2.878-2.831a1 1 0 0 0 .013-1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-level-down_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLevelDown;
